import { createRootRoute, HeadContent, Outlet } from '@tanstack/react-router';
import { GlobalLoadingIndicator } from '@/components/GlobalLoadingIndicator';
import { Toaster } from 'sonner';
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getBrand } from '@/utils/pageTitle';

const DynamicTitle = () => {
  const { tenant } = useAuth();

  useEffect(() => {
    if (!tenant) {
      return;
    }

    const current = document.title;
    const separator = ' | ';
    const page = current.includes(separator)
      ? current.slice(0, current.lastIndexOf(separator))
      : current;

    if (!page) {
      return;
    }

    document.title = `${page} | ${getBrand(tenant)}`;
  }, [tenant]);

  return null;
};

export const Route = createRootRoute({
  head: () => ({}),
  component: () => (
    <>
      <HeadContent />
      <DynamicTitle />
      <GlobalLoadingIndicator />
      <Toaster position='bottom-right' closeButton />
      <Outlet />
    </>
  ),
});
